module.exports = __webpack_public_path__ + "img/9_heart.eb1d9025.jpg";